export const formatWithLineBreaks = (text: string): JSX.Element[] =>
  text &&
  text.split('\n').map((sub) => (
    <>
      {sub}
      <br />
    </>
  ));
